
import React from "react";
import { Helmet } from "react-helmet";
import "./pagestyles/RedboxYoutube.css";

const RedboxYoutube = () => {
  return (
    <>
      <Helmet>
        <title>Redbox YouTube | Watch Originals</title>
        <meta
          name="description"
          content="Watch original journalism, interviews, and documentaries from Redbox YouTube."
        />
      </Helmet>

      <div className="youtube-container">

        {/* Channel Header */}
        <div className="channel-header">
          <h1>Redbox YouTube</h1>
          <p>Original Journalism • Interviews • Documentaries</p>
        </div>

        {/* Main Featured Video */}
        <div className="main-video">
          <iframe
            src="https://www.youtube.com/embed/Jp_MqJoa7ys"
            title="Redbox Featured Video"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>

        {/* Video Grid */}
        <div className="video-grid">

          <div className="video-card">
            <img
              src="https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=600&h=400&fit=crop"
              alt="Studio Documentary"
            />
            <h3>Inside Redbox Studios</h3>
            <span>2.3M views • 2 weeks ago</span>
          </div>

          <div className="video-card">
            <img
              src="https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=600&h=400&fit=crop"
              alt="Executive Interview"
            />
            <h3>Exclusive CEO Interview</h3>
            <span>1.1M views • 5 days ago</span>
          </div>

          <div className="video-card">
            <img
              src="https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?w=600&h=400&fit=crop"
              alt="Market Documentary"
            />
            <h3>Global Markets Explained</h3>
            <span>890K views • 1 week ago</span>
          </div>

          <div className="video-card">
            <img
              src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=600&h=400&fit=crop"
              alt="Economic Analysis"
            />
            <h3>Economic Outlook 2026</h3>
            <span>640K views • 3 days ago</span>
          </div>

        </div>

      </div>
    </>
  );
};

export default RedboxYoutube;